import { validateEnumTranslations } from '../../safety_checks';
import { ServiceAreaType } from '../professional/service-area.schema';

/**
 * Labels affichés pour chaque type de zone d'intervention d'un pro.
 * Consommé par le composant `area-list` (shared-components) et la modale
 * de gestion des zones côté frontend-web.
 */
export const SERVICE_AREA_TYPE_TRANSLATE_KEY = 'SERVICE_AREA_TYPE_';

export const ServiceAreaTypeTranslation = {
  'fr-FR': {
    [`${SERVICE_AREA_TYPE_TRANSLATE_KEY}${ServiceAreaType.CITY}`]: 'Ville',
    [`${SERVICE_AREA_TYPE_TRANSLATE_KEY}${ServiceAreaType.DEPARTMENT}`]: 'Département',
    [`${SERVICE_AREA_TYPE_TRANSLATE_KEY}${ServiceAreaType.REGION}`]: 'Région',
  },
};

validateEnumTranslations(ServiceAreaType, ServiceAreaTypeTranslation, SERVICE_AREA_TYPE_TRANSLATE_KEY, true);
